<template>
  <div class="newQuestion">
    <!-- <span class="el-icon-house"> / 题库管理 / 题目管理 / 新建题目</span> -->
    <div class="backStyle">
      <el-page-header :content="$route.query.state" @back="goback"></el-page-header>
    </div>

    <div class="wrapper">
      <div class="content">
        <el-form size="small" :inline="true" :model="form">
          <div style="background:#f5f7fa;padding:20px;border-radius: 5px;margin-bottom:20px;">
            <div style="font-size:16px;font-weight: 500px;margin-bottom:20px;">
              <span style="font-weight: bold;">基础信息</span>
            </div>

            <el-form-item label="题目序号" required v-if="!$route.query.code_other">
              <el-input-number v-model="form.sort_num" :precision="1" :step="0.1"></el-input-number>
            </el-form-item>

            <br />

            <el-form-item label="题目格式" required>
              <el-switch @change="changeSwitch" v-model="form.show_type" active-color="#13ce66" inactive-color="#409EFF" active-text="markdown" inactive-text="富文本">
              </el-switch>
            </el-form-item>

            <br />
            <el-form-item label="题目类型" required>
              <el-radio-group v-model="form.type" size="mini">
                <el-radio :disabled="isEdit" :label="1">单选题</el-radio>
                <el-radio :disabled="isEdit" :label="2">多选题</el-radio>
                <el-radio :disabled="isEdit" :label="3">判断题</el-radio>
                <el-radio :disabled="isEdit" :label="4">填空题</el-radio>
                <el-radio :disabled="isEdit" :label="5">简答题</el-radio>
                <el-radio :disabled="isEdit" :label="6">综合题</el-radio>
                <el-radio :label="7">阅读程序</el-radio>
                <el-radio :label="8">完善程序</el-radio>
                <el-radio :label="9">编程题</el-radio>
              </el-radio-group>
            </el-form-item>

            <br />
          </div>
          <el-drawer title="选择编程题" size="80%" :visible.sync="ojDrawerShow" :direction="'ltr'" :before-close="handleCloseOjDrawer">
            <div class="oj-problem-view">
              <el-form :model="ojParams" label-width="80px" size="mini" inline style="position: sticky;top: 0px;z-index: 10;background: #fff;">
                <el-form-item label="标题">
                  <el-input v-model="ojParams.title" prefix-icon="el-icon-search" placeholder="请输入标题" clearable @keyup.enter.native="getAdminGetOjProblemList"></el-input>
                </el-form-item>
                <el-form-item label="题目编号">
                  <el-input v-model="ojParams.code" prefix-icon="el-icon-search" placeholder="请输入题目编号" clearable @keyup.enter.native="getAdminGetOjProblemList"></el-input>
                </el-form-item>
                <el-form-item label="是否可见">
                  <el-select v-model="ojParams.isVisible" clearable>
                    <el-option label="全部" value=""></el-option>
                    <el-option label="可见" value="1"></el-option>
                    <el-option label="不可见" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="getAdminGetOjProblemList" icon="el-icon-search">查询</el-button>
                </el-form-item>
              </el-form>
              <el-divider>
                <!-- 分隔符 -->
              </el-divider>
              <el-table :data="ojProblemList" size="mini" stripe style="width: 100%;padding: 0 20px" :header-cell-style="{ background: '#f5f7fa' }">
                <el-table-column prop="sort_num" label="序号"> </el-table-column>
                <el-table-column prop="code" label="题目编号"> </el-table-column>
                <el-table-column prop="title" label="问题名称" show-overflow-tooltip>
                </el-table-column>

                <el-table-column prop="created_time" label="创建时间"> </el-table-column>
                <el-table-column label="标签">
                  <template slot-scope="scope">
                    <el-tag size="mini" v-if="scope.row.sourceTitle != null">{{
            scope.row.sourceTitle
          }}</el-tag>
                    <span v-if="scope.row.problemTagArr.length === 0 ? false : true">
                      <span v-for="item in scope.row.problemTagArr" :key="item.id">
                        <el-tag size="mini" type="success">{{
                item.tagInfo.title
              }}</el-tag>
                      </span>
                    </span>
                    <el-tag size="mini" v-if="scope.row.difficultyTitle != null" type="danger">{{ scope.row.difficultyTitle }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="是否可见">
                  <template slot-scope="scope">
                    {{scope.row.visible?'是':'否'}}
                  </template>
                </el-table-column>
                <el-table-column label="显示类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.description_show_type === 1">富文本</span>
                    <span v-if="scope.row.description_show_type === 2">MarkDown</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" @click="methodSelectOj(scope.row)">选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="fr" style="padding:10px 20px;text-align: right">
                <el-pagination @current-change="handleOjChangePage" :current-page="ojParams.page_no" :page-size="ojParams.page_size" layout="total, prev, pager, next, jumper" :total="ojParams.total">
                </el-pagination>
              </div>
            </div>
          </el-drawer>
          <div style="background: rgb(245, 247, 250);padding:20px;border-radius: 10px;" v-if="form.type == 7 || form.type == 8">
            <el-form-item label="题干信息" required>
              <div @click="AddOneChoice('t3')" v-if="form.show_type === true" class="question-title3" v-html="form.title_other_md"></div>
              <div v-else @click="AddOneChoice('t3')" class="question-title3" v-html="form.title_other"></div>
              <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                            @click="AddOneChoice('t3')"></el-button> -->
            </el-form-item>

            <!--
            <div style="overflow: hidden;margin-top: 0px;margin-bottom:20px;">
                  <div style="float: right;">
                    <el-button
                      size="mini"
                      plain
                      icon="el-icon-edit"
                      @click="AddOneChoice('t3')"
                      >编辑题干
                    </el-button>
                  </div>
                </div>
                  -->
          </div>
          <div v-else>
            <el-form-item label="题目名称" required>
              <template v-if="form.type ==9">
                <div @click="ojDrawerShow=true" class="question-title3" v-html="form.title||`<span style='color:#999'>此处编程题的title只在此使用，其他地方都不用<span>`"></div>
              </template>
              <template v-else>
                <div @click="AddOneChoice('t')" v-if="form.show_type === true" class="question-title3" v-html="form.title_md"></div>
                <div @click="AddOneChoice('t')" v-else class="question-title3" v-html="form.title"></div>
              </template>
            </el-form-item>
          </div>

          <!-- <div v-if="form.type != 7 && form.type != 8">
                        <br />
                    </div> -->
          <div v-if="form.show_type === true">
            <el-form-item v-if="form.type == '1' || form.type == '2'" label="试题选项" required>
              <div class="option-wrapper">
                <span class="option-tab">选项{{ form.options_md[0].title }}</span>
                <div style="overflow: hidden; margin-top: 10px;">
                  <div @click="AddOneChoice('a')" class="option-input2" v-html="form.options_md[0].content"></div>
                  <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                        @click="AddOneChoice('a')"></el-button> -->
                </div>
              </div>
              <div class="option-wrapper">
                <span class="option-tab">选项{{ form.options_md[1].title }}</span>

                <div style="overflow: hidden; margin-top: 10px;">
                  <div @click="AddOneChoice('b')" class="option-input2" v-html="form.options_md[1].content"></div>
                  <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                        @click="AddOneChoice('a')"></el-button> -->
                </div>
              </div>
              <div class="option-wrapper">
                <span class="option-tab">选项{{ form.options_md[2].title }}</span>
                <div style="overflow: hidden;margin-top: 10px;">
                  <div @click="AddOneChoice('c')" class="option-input2" v-html="form.options_md[2].content"></div>
                  <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                        @click="AddOneChoice('c')"></el-button> -->
                </div>
              </div>
              <div class="option-wrapper">
                <span class="option-tab">选项{{ form.options_md[3].title }}</span>
                <div style="overflow: hidden;margin-top: 10px;">
                  <div @click="AddOneChoice('d')" class="option-input2" v-html="form.options_md[3].content"></div>
                  <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                        @click="AddOneChoice('d')"></el-button> -->
                </div>
              </div>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item v-if="form.type == '1' || form.type == '2'" label="试题选项" required>
              <div class="option-wrapper">
                <span class="option-tab">选项{{ form.options[0].title }}</span>
                <div style="overflow: hidden;margin-top: 10px;margin-left:10px;">
                  <div @click="AddOneChoice('a')" class="option-input2" v-html="form.options[0].content"></div>
                  <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                        @click="AddOneChoice('a')"></el-button> -->
                </div>
              </div>
              <div class="option-wrapper">
                <span class="option-tab">选项{{ form.options[1].title }}</span>
                <div style="overflow: hidden;margin-top: 10px;margin-left:10px;">
                  <div @click="AddOneChoice('b')" class="option-input2" v-html="form.options[1].content"></div>
                  <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                        @click="AddOneChoice('b')"></el-button> -->
                </div>
              </div>
              <div class="option-wrapper">
                <span class="option-tab">选项{{ form.options[2].title }}</span>
                <div style="overflow: hidden;margin-top: 10px;margin-left:10px;">
                  <div @click="AddOneChoice('c')" class="option-input2" v-html="form.options[2].content"></div>
                  <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                        @click="AddOneChoice('c')"></el-button> -->
                </div>
              </div>
              <div class="option-wrapper">
                <span class="option-tab">选项{{ form.options[3].title }}</span>
                <div style="overflow: hidden;margin-top: 10px;margin-left:10px;">
                  <div @click="AddOneChoice('d')" class="option-input2" v-html="form.options[3].content"></div>
                  <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                        @click="AddOneChoice('d')"></el-button> -->
                </div>
              </div>
            </el-form-item>
          </div>
          <el-form-item v-if="form.type == '1'" label="正确答案" required>
            <el-radio-group v-model="form.answer" size="mini">
              <el-radio label="A"></el-radio>
              <el-radio label="B"></el-radio>
              <el-radio label="C"></el-radio>
              <el-radio label="D"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.type == '2'" label="正确答案" required>
            <el-checkbox-group v-model="form.answerlist">
              <el-checkbox label="A"></el-checkbox>
              <el-checkbox label="B"></el-checkbox>
              <el-checkbox label="C"></el-checkbox>
              <el-checkbox label="D"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item v-if="form.type == '3'" label="正确答案" required>
            <el-radio-group v-model="form.judge_answer" size="mini">
              <el-radio label="A">正确</el-radio>
              <el-radio label="B">错误</el-radio>
            </el-radio-group>
          </el-form-item>
          <div v-if="form.type != 7 && form.type != 8">
            <br />
          </div>
          <el-form-item v-if="form.type == '4'" label="正确答案" required>
            <div v-for="item of form.answerArr" :key="item.id">
              <el-input class="anwser_arr" v-model="item.content" placeholder="请输入答案内容"></el-input>
              <icon style="margin-left: 10px; font-size: 16px; cursor: pointer" @click.prevent="removeAnswer(item)" class="el-icon-delete"></icon>
              <icon style="margin-left: 10px; font-size: 16px; cursor: pointer" @click.prevent="addAnswers(item, item.id)" class="el-icon-plus">
              </icon>
            </div>
            <div>
              <el-button icon="el-icon-plus" round @click="addAnswer">添加</el-button>
            </div>
            <div class="answer_tips">
              <span>【注】</span>
              <span>
                <span>1.如果答案有多种表达方式,
                  例如：二和2，点击“+”按钮产生分隔符，组成答案“二┇2”;</span>
                <br />
                <span style="display: inline-block;margin-left: 42px;">2. 填空题答案中，暂不支持公式和图片（无法判断）</span></span>
            </div>
          </el-form-item>
          <div v-if="form.type == '5'">
            <el-form-item v-if="form.type == '5'" label="正确答案" required>
              <div @click="AddOneChoice('short')" class="question-title3" v-html="form.short_answer"></div>
              <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                @click="AddOneChoice('short')"></el-button> -->
            </el-form-item>
          </div>
          <el-form-item v-if="form.type == '6'" label="项目模板" required prop="img_url">
            <el-upload action="" :http-request="uploadFile" :on-change="handleChangeFile1" :auto-upload="false" :limit="1" :file-list="form.fileList1" list-type="file">
              <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
              <div slot="tip" class="el-upload__tip">
                <span>【注】</span>
                <span>
                  Scratch科目请上传sb3格式文件，Python科目请上传.py格式文件
                </span>
              </div>
            </el-upload>
          </el-form-item>
          <div v-if="form.type != 7 && form.type != 8">
            <br />
          </div>
          <el-form-item v-if="form.type == '6'" label="正确源码" required prop="img_url">
            <el-upload action="" :http-request="uploadFile" :on-change="handleChangeFile2" :auto-upload="false" :limit="1" :file-list="form.fileList2" list-type="file">
              <el-button size="mini" type="primary" plain>点击上传<i class="el-icon-upload el-icon--right"></i></el-button>
              <div slot="tip" class="el-upload__tip">
                <span>【注】</span>
                <span>
                  Scratch科目请上传sb3格式文件，Python科目请上传.py格式文件
                </span>
              </div>
            </el-upload>
          </el-form-item>

          <div v-if="form.type != 7 && form.type != 8 && form.type != 9">
            <el-form-item label="试题解析" required>
              <div v-if="form.show_type === true" class="question-title3" v-html="form.analysis_md" @click="AddOneChoice('s')"></div>
              <div v-else class="question-title3" v-html="form.resolution" @click="AddOneChoice('s')"></div>
              <!-- <el-button style="margin-left: 10px;" type="" icon="el-icon-edit"
                                @click="AddOneChoice('s')"></el-button> -->
            </el-form-item>
          </div>
          <el-form-item label="* 知识点" v-if="form.type != 7 && form.type != 8 && form.type !=9">
            <el-select v-model="form.tagIdArr" multiple collapse-tags filterable placeholder="请选择">
              <el-option v-for="item in testQuestionTagList" :key="item.id" :label="item.title" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div v-for="(item, index) in specialQuestionTypesList" :key="index" style="margin-top:20px;margin-bottom:20px">
          <div style="background:#f5f7fa; padding: 20px; border-radius: 5px;">
            <div>
              <div style="margin-bottom: 10px;font-size: 14px;">
                <span style="font-weight: bold;" v-if="item.type == 3">判断题</span>
                <span style="font-weight: bold;" v-if="item.type == 1">选择题</span>

                <span style="font-weight: bold;margin-left:10px; ">{{
                  '(' + (index + 1) + ')'
                }}</span>
              </div>

              <el-divider></el-divider>
              <!-- <div style="margin-bottom: 15px;margin-left: 10px;">
                                <el-switch @change="changeSwitch1(item)" style="display: block" v-model="item.show_type"
                                    active-color="#13ce66" inactive-color="#409EFF" active-text="markdown"
                                    inactive-text="富文本">
                                </el-switch>
                            </div> -->

              <div style="margin: 10px;font-weight: bold;font-size: 14px;">
                题目名称
              </div>

              <div style="overflow: hidden;cursor:pointer">
                <div @click="AddOneChoice1(item, index)" v-if="form.show_type === true" class="question-title2" v-html="item.title_md"></div>
                <div v-else @click="AddOneChoice1(item, index)" class="question-title2" v-html="item.title"></div>
              </div>
            </div>
            <div style="padding: 10px;">
              <div v-if="item.type == 3">
                <div style="font-weight: bold;font-size: 14px;margin-top:10px;">
                  正确答案
                </div>
                <div style="margin-top: 10px;">
                  <el-radio-group v-model="item.judge_answer" size="mini">
                    <el-radio label="A">正确</el-radio>
                    <el-radio label="B">错误</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div v-if="item.type == 1">
                <div style="font-weight: bold;font-size: 14px;margin-top:10px;">
                  题目选项
                </div>

                <div v-if="form.show_type === true">
                  <div class="option-wrapper">
                    <span class="option-tab">选项{{ item.options_md[0].title }}</span>
                    <div style="overflow: hidden; margin-top: 10px;" @click="AddOneChoice2(item, index)">
                      <div class="option-input1" v-html="item.options_md[0].content"></div>
                    </div>
                  </div>
                  <div class="option-wrapper">
                    <span class="option-tab">选项{{ item.options_md[1].title }}</span>
                    <div style="overflow: hidden;margin-top: 10px;">
                      <div @click="AddOneChoice3(item, index)" class="option-input1" v-html="item.options_md[1].content"></div>
                    </div>
                  </div>
                  <div class="option-wrapper">
                    <span class="option-tab">选项{{ item.options_md[2].title }}</span>
                    <div style="overflow: hidden;margin-top: 10px;">
                      <div @click="AddOneChoice4(item, index)" class="option-input1" v-html="item.options_md[2].content"></div>
                    </div>
                  </div>
                  <div class="option-wrapper">
                    <span class="option-tab">选项{{ item.options_md[3].title }}</span>
                    <div style="overflow: hidden;margin-top: 10px;">
                      <div @click="AddOneChoice5(item, index)" class="option-input1" v-html="item.options_md[3].content"></div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="option-wrapper" style="margin-top: 10px;">
                    <span class="option-tab">选项{{ item.options[0].title }}</span>
                    <div style="overflow: hidden;margin-top: 10px;">
                      <div @click="AddOneChoice2(item, index)" class="option-input1" v-html="item.options[0].content"></div>
                    </div>
                  </div>
                  <div class="option-wrapper">
                    <span class="option-tab">选项{{ item.options[1].title }}</span>
                    <div style="overflow: hidden;margin-top: 10px;">
                      <div @click="AddOneChoice3(item, index)" class="option-input1" v-html="item.options[1].content"></div>
                    </div>
                  </div>
                  <div class="option-wrapper">
                    <span class="option-tab">选项{{ item.options[2].title }}</span>
                    <div style="overflow: hidden;margin-top: 10px;">
                      <div @click="AddOneChoice4(item, index)" class="option-input1" v-html="item.options[2].content"></div>
                    </div>
                  </div>
                  <div class="option-wrapper">
                    <span class="option-tab">选项{{ item.options[3].title }}</span>
                    <div style="overflow: hidden;margin-top: 10px;">
                      <div @click="AddOneChoice5(item, index)" class="option-input1" v-html="item.options[3].content"></div>
                    </div>
                  </div>
                </div>
                <div style="font-weight: bold;font-size: 14px;">正确答案</div>
                <el-radio-group v-model="item.answer" size="mini" style="margin-top: 10px">
                  <el-radio label="A"></el-radio>
                  <el-radio label="B"></el-radio>
                  <el-radio label="C"></el-radio>
                  <el-radio label="D"></el-radio>
                </el-radio-group>
              </div>
              <div style="margin-top: 20px;font-weight: bold;font-size: 14px;">
                试题解析
              </div>
            </div>
            <div style="overflow: hidden;cursor:pointer">
              <div @click="AddOneChoiceanalysis(item, index)" v-if="form.show_type === true" class="question-title2" v-html="item.analysis_md"></div>
              <div v-else @click="AddOneChoiceanalysis(item, index)" class="question-title2" v-html="item.resolution"></div>
            </div>
            <div style="margin:10px 10px 0 10px; ">
              <div style="font-weight: bold;font-size: 14px;margin-top:20px;">
                知识点
              </div>
              <div style="margin-top: 10px;">
                <el-select v-model="item.tagIdArr" multiple collapse-tags filterable placeholder="请选择" style="width: 50%;">
                  <el-option v-for="item1 in testQuestionTagList" :key="item1.id" :label="item1.title" :value="item1.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div style="margin-top: 20px;margin-left: 10px;">
              <el-row>
                <el-col :span="24">
                  <div class="submit">
                    <el-button style="float:left" size="small" type="primary" @click="addNewQuestionType(item, index)">保存题目</el-button>

                    <el-button style="float:left" size="small" @click="DeleteQuestion(item, index)">移除题目</el-button>

                    <!-- <el-button size="small" @click="DeleteQuestion(item)">移除</el-button> -->
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <div style="padding-bottom: 10px;" v-if="form.type == 7 || form.type == 8">
          <div class="boxStyle">
            <span style="font-weight: bold; font-size: 14px;color:white;">增加题型
            </span>
            <el-button style="margin-left: 10px;" size="mini" @click="addTrueOrFalse">新增判断题</el-button>
            <el-button size="mini" @click="choiceQuestion">新增选择题</el-button>
          </div>
        </div>

        <el-row v-if="form.type != 7 && form.type != 8">
          <el-col :span="24">
            <div class="submit">
              <el-button size="small" type="primary" @click="adminAddOrUpdateQuestion">保存试题</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-drawer title="题目内容" z-index="1000" :visible.sync="drawer_title3" :direction="direction" size="50%">
        <markdownShow v-if="form.show_type === true" @changeMardown="changeMardownTitleOther" :markdown="form.title_other_md" @SaveMarkDown="SaveMarkDownTitleOther">
        </markdownShow>
        <tinymce v-else ref="title" v-model="form.title_other" :height="Editor_Height" />
      </el-drawer>
      <el-drawer title="题目内容" z-index="1000" :visible.sync="drawer_title" :direction="direction" size="50%">
        <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown" :markdown="form.title_md" @SaveMarkDown="SaveMarkDown">
        </markdownShow>
        <tinymce v-else ref="title" v-model="form.title" :height="Editor_Height" />
      </el-drawer>
      <el-drawer title="选项A内容" z-index="1000" :visible.sync="drawer_a" :direction="direction" size="50%">
        <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown1" :markdown="form.options_md[0].content" @SaveMarkDown="SaveMarkDown1">
        </markdownShow>
        <tinymce v-else ref="question_a" v-model="form.options[0].content" :height="Editor_Height" />
      </el-drawer>
      <el-drawer title="选项B内容" z-index="1000" :visible.sync="drawer_b" :direction="direction" size="50%">
        <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown2" :markdown="form.options_md[1].content" @SaveMarkDown="SaveMarkDown2">
        </markdownShow>
        <tinymce v-else ref="question_b" v-model="form.options[1].content" :height="Editor_Height" />
      </el-drawer>
      <el-drawer title="选项C内容" z-index="1000" :visible.sync="drawer_c" :direction="direction" size="50%">
        <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown3" :markdown="form.options_md[2].content" @SaveMarkDown="SaveMarkDown3">
        </markdownShow>
        <tinymce v-else ref="question_c" v-model="form.options[2].content" :height="Editor_Height" />
      </el-drawer>
      <el-drawer title="选项D内容" z-index="1000" :visible.sync="drawer_d" :direction="direction" size="50%">
        <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown4" :markdown="form.options_md[3].content" @SaveMarkDown="SaveMarkDown4">
        </markdownShow>
        <tinymce v-else ref="question_d" v-model="form.options[3].content" :height="Editor_Height" />
      </el-drawer>
      <el-drawer title="试题解析" z-index="1000" :visible.sync="drawer_s" :direction="direction" size="50%">
        <markdownShow v-if="form.show_type === true" @changeMardown="changeMardown5" :markdown="form.analysis_md" @SaveMarkDown="SaveMarkDown5">
        </markdownShow>
        <tinymce v-else ref="resolution" v-model="form.resolution" :height="Editor_Height" />
      </el-drawer>
      <el-drawer title="简答题答案" z-index="1000" :visible.sync="drawer_short" :direction="direction" size="50%">
        <tinymce ref="short_answer" v-model="form.short_answer" :height="Editor_Height" />
      </el-drawer>
      <el-drawer title="题目内容" z-index="1000" :visible.sync="drawer_titleContent" :direction="direction" size="50%">
        <div v-if="form.show_type === true">
          <div v-if="specialQuestionTypesList.length != 0">
            <markdownShow v-if="isShow" @changeMardown="changeMardownTitle" :markdown="specialQuestionTypesList[indexNum].title_md" @SaveMarkDown="SaveMarkDownTitle">
            </markdownShow>
          </div>
        </div>
        <div v-else>
          <div v-if="specialQuestionTypesList.length != 0">
            <tinymce v-if="isShow" ref="titleContent" v-model="specialQuestionTypesList[indexNum].title" :height="Editor_Height" />
          </div>
        </div>
      </el-drawer>
      <el-drawer title="选项A内容" z-index="1000" :visible.sync="drawer_a1" :direction="direction" size="50%">
        <div v-if="form.show_type === true">
          <div v-if="specialQuestionTypesList.length != 0">
            <markdownShow v-if="isShow" @changeMardown="changeMardownA" :markdown="
                specialQuestionTypesList[indexNum].options_md[0].content
              " @SaveMarkDown="SaveMarkDownA">
            </markdownShow>
          </div>
        </div>
        <div v-else>
          <div v-if="specialQuestionTypesList.length != 0">
            <tinymce v-if="isShow" ref="titleA" v-model="specialQuestionTypesList[indexNum].options[0].content" :height="Editor_Height" />
          </div>
        </div>
      </el-drawer>
      <el-drawer title="选项B内容" z-index="1000" :visible.sync="drawer_b1" :direction="direction" size="50%">
        <div v-if="form.show_type === true">
          <div v-if="specialQuestionTypesList.length != 0">
            <markdownShow v-if="isShow" @changeMardown="changeMardownB" :markdown="
                specialQuestionTypesList[indexNum].options_md[1].content
              " @SaveMarkDown="SaveMarkDownB">
            </markdownShow>
          </div>
        </div>
        <div v-else>
          <div v-if="specialQuestionTypesList.length != 0">
            <tinymce v-if="isShow" ref="titleB" v-model="specialQuestionTypesList[indexNum].options[1].content" :height="Editor_Height" />
          </div>
        </div>
      </el-drawer>
      <el-drawer title="选项C内容" z-index="1000" :visible.sync="drawer_c1" :direction="direction" size="50%">
        <div v-if="form.show_type === true">
          <div v-if="specialQuestionTypesList.length != 0">
            <markdownShow v-if="isShow" @changeMardown="changeMardownC" :markdown="
                specialQuestionTypesList[indexNum].options_md[2].content
              " @SaveMarkDown="SaveMarkDownC">
            </markdownShow>
          </div>
        </div>
        <div v-else>
          <div v-if="specialQuestionTypesList.length != 0">
            <tinymce v-if="isShow" ref="titleC" v-model="specialQuestionTypesList[indexNum].options[2].content" :height="Editor_Height" />
          </div>
        </div>
      </el-drawer>
      <el-drawer title="选项D内容" z-index="1000" :visible.sync="drawer_d1" :direction="direction" size="50%">
        <div v-if="form.show_type === true">
          <div v-if="specialQuestionTypesList.length != 0">
            <markdownShow v-if="isShow" @changeMardown="changeMardownD" :markdown="
                specialQuestionTypesList[indexNum].options_md[3].content
              " @SaveMarkDown="SaveMarkDownD">
            </markdownShow>
          </div>
        </div>
        <div v-else>
          <div v-if="specialQuestionTypesList.length != 0">
            <tinymce v-if="isShow" ref="titleD" v-model="specialQuestionTypesList[indexNum].options[3].content" :height="Editor_Height" />
          </div>
        </div>
      </el-drawer>
      <el-drawer title="题目内容" z-index="1000" :visible.sync="drawer_title2" :direction="direction" size="50%">
        <div v-if="form.show_type === true">
          <div v-if="specialQuestionTypesList.length != 0">
            <markdownShow v-if="isShow" @changeMardown="changeMardownTitle2" :markdown="specialQuestionTypesList[indexNum].analysis_md" @SaveMarkDown="SaveMarkDownTitle2">
            </markdownShow>
          </div>
        </div>
        <div v-else>
          <div v-if="specialQuestionTypesList.length != 0">
            <tinymce v-if="isShow" ref="titleresolution" v-model="specialQuestionTypesList[indexNum].resolution" :height="Editor_Height" />
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce'

import {
  adminAddOrUpdateQuestion,
  adminGetTestQuestionTagListBySubjectIdWithoutPage,
  adminGetTestQuestionByBankIdAndCodeOther,
  adminUpdateQuestionShowType,
  adminUpdateQuestionTitleOther,
  adminDeleteQuestion,
  // adminDeleteQuestion,
  // adminGetTestQuestionTagListBySubjectIdWithoutPage
} from '@/api/admin'
import { adminGetOjProblemList } from '@/api/adminOj'
import uploadFile from '@/config/uploadFile'
import markdownShow from '@/components/markdownShow'

export default {
  name: 'add-question',
  data() {
    return {
      isEdit: false,
      questionId: '',
      questionList: [],
      code_other: '',
      // show_type1: false,
      testQuestionTagList: [],
      drawer_title2: false,
      drawer_a1: false,
      drawer_b1: false,
      drawer_c1: false,
      drawer_d1: false,
      isShow: true,
      indexNum: 0,
      drawer_titleContent: false,
      specialQuestionTypesList: [],
      form1: {
        specialQuestionTypes: [],
      },
      form2: {
        tagIdArr: [],
        title_md: '',
        analysis_md: '',
        answer: '',
        title: '',
        type: '3',
        judge_answer: '',
        resolution: '无',
        options: [
          { title: 'A', content: '' },
          { title: 'B', content: '' },
          { title: 'C', content: '' },
          { title: 'D', content: '' },
        ],
        options_md: [
          { title: 'A', content: '' },
          { title: 'B', content: '' },
          { title: 'C', content: '' },
          { title: 'D', content: '' },
        ],
      },
      options1: [],
      formType: true,
      page_title: '添加试题',
      bank_id: '', //题库id
      subject_id: '', //科目id
      drawer_title3: false,
      drawer_title: false,
      drawer_a: false,
      drawer_b: false,
      drawer_c: false,
      drawer_d: false,
      drawer_s: false, //试题解析
      drawer_short: false, //简答题答案
      direction: 'rtl',
      Editor_Height: '',

      title: '',
      target: 'form.question_a', //富文本目标输入
      form: {
        title_other_md: '',
        title_other: '',
        tagIdArr: [],
        show_type: true,
        title_md: '',
        analysis_md: '无',
        options_md: [
          {
            title: 'A',
            content: '',
          },
          {
            title: 'B',
            content: '',
          },
          {
            title: 'C',
            content: '',
          },
          {
            title: 'D',
            content: '',
          },
        ],
        sort_num: 0,
        type: 1,
        title: '',
        title_str: '', //富文本提取纯文本
        options: [
          {
            title: 'A',
            content: '',
          },
          {
            title: 'B',
            content: '',
          },
          {
            title: 'C',
            content: '',
          },
          {
            title: 'D',
            content: '',
          },
        ],

        final_answer: '', //最终答案

        answer: '', //答案
        resolution: '无', // 试题解析
        answerlist: [], //多选题答案
        judge_answer: '', //判断题答案
        short_answer: '', //简单题答案
        answerArr: [
          {
            id: 1,
            content: '',
          },
        ],
        fileList1: [], // 模板文件地址
        fileList2: [], //正确文件地址
        uploadFileTime: false,
        //知识点组
        testQuestionTagGroupList: [],
        question: {},
        sort_index: 0,
      },
      // OJ部分
      ojDrawerShow: false,
      ojParams: {
        title: '',//标题
        code: '',//编号
        isPlatform: 1,//平台
        isContest: '',//是否比赛题目 不传是全部
        isVisible: '',// 是否可见
        page_no: 1,
        page_size: 20,
        total: 0
      },
      ojProblemList: [],
      ojSelectedItem: null
    }
  },

  watch: {
    'form.type'(val) {
      if (val === 9) {
        this.getAdminGetOjProblemList();
      }
    },
    code_other(val) {
      if (val) {
        this.isEdit = true
      } else {
        this.isEdit = false
      }
    },
    drawer_title3(val) {
      console.log(val, 789146536)
      if (this.code_other) {
        if (val == false) {
          adminUpdateQuestionTitleOther({
            code_other: this.code_other,
            title_other: this.form.title_other,
            title_other_md: this.form.title_other_md,
          }).then((res) => {
            console.log(res, 78945646)
            this.$message.success('题干已保存')
          })
          // title_other
          // title_other_md
        }
      }
    },
    // "form.title": function (val) {
    //   this.form.title_str = this.getSimpleText(val);
    // },
  },

  components: {
    Tinymce,
    markdownShow: markdownShow,
  },
  beforeDestroy() {
    sessionStorage.removeItem('ExamData')
  },
  mounted() {
    this.title = this.$route.query.title
    this.bank_id = this.$route.query.id
    console.log(this.bank_id, 7894763)
    this.subject_id = this.$route.query.subject_id
    this.Editor_Height = document.documentElement.clientHeight + 'px'

    // console.log(this.$route.params.question);
    if (sessionStorage.getItem('ExamData') != null) {
      // var question = this.$route.params.question;

      console.log('编辑题目')

      this.question = JSON.parse(sessionStorage.getItem('ExamData'))
      this.code_other = this.question.code_other
      if (this.code_other) {
        this.isEdit = true
        this.adminGetTestQuestionByBankIdAndCodeOther()
      } else {
        this.isEdit = false
      }
      console.log('题目信息')
      console.log(this.question)
      if (this.question.show_type === 2) {
        this.form.show_type = true
        this.formType = true

        this.form.title_str = this.question.title_md
      } else {
        this.form.show_type = false
        this.formType = false

        this.form.title_str = this.question.title
      }

      console.log('编辑题目')
      this.page_title = '编辑试题'
      this.form.sort_num = this.question.sort_num
      this.form.type = this.question.type
      this.form.title = this.question.title
      this.form.options = JSON.parse(this.question.options)
      this.form.title_md = this.question.title_md
      this.form.title_md = this.question.title_md

      if (this.question.options_md != null) {
        this.form.options_md = JSON.parse(this.question.options_md)
      }

      if (this.question.type == '1') {
        console.log('单选题答案')
        this.form.answer = this.question.answer
      } else if (this.question.type == '2') {
        console.log(this.question, 123456)
        this.form.answerlist = this.question.answer.split(',').sort()
        console.log(this.form.answerlist, 123456)
      } else if (this.question.type == '3') {
        console.log('判断题答案')
        this.form.options[0].title = 'A'
        this.form.options[0].content = '正确'
        this.form.options[1].title = 'B'
        this.form.options[1].content = '错误'
        this.form.judge_answer = this.question.answer
      } else if (this.question.type == '4') {
        console.log('填空题答案')
        console.log(this.question.answer, 123456)
        var answers = ''
        answers = this.question.answer.split('┅')

        this.form.answerArr = []
        for (let k = 0; k < answers.length; k++) {
          var answer = {
            id: k,
            content: answers[k],
          }
          this.form.answerArr.push(answer)
        }
      } else if (this.question.type == '5') {
        console.log('简单题答案')
        this.form.short_answer = this.question.answer
      } else if (this.question.type == '6') {
        console.log('综合题录入')

        console.log(JSON.parse(this.question.answer)[0])

        this.form.fileList1.push(JSON.parse(this.question.answer)[0])
        this.form.fileList2.push(JSON.parse(this.question.answer)[1])
      }

      this.form.resolution = this.question.analysis
      this.form.analysis_md = this.question.analysis_md

      console.log(this.question.options)
    } else {
      console.log('新增题目')

      this.isEdit = false

      this.form.sort_num = parseFloat(this.$route.query.question_num) + 1
    }

    this.adminGetTestQuestionTagListBySubjectIdWithoutPage()
  },
  methods: {
    // del(val, index) {
    //     console.log(index)
    //     this.specialQuestionTypesList.splice(this.specialQuestionTypesList.indexOf(val), 1);
    // },
    // DeleteQuestion(val) {
    //     console.log("删除题目");
    //     console.log(val, 7896453)

    //     this.$confirm("确定删除本道题吗?", "提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning",
    //     }).then(() => {
    //         adminDeleteQuestion({
    //             questionId: val.id,
    //         }).then((res) => {
    //             console.log("删除题目");
    //             console.log(res);
    //             if (res.is_delete) {
    //                 this.$message.success("删除成功");
    //                 this.adminGetTestQuestionByBankIdAndCodeOther()
    //             }
    //         });
    //     });
    // },

    //删除题目
    DeleteQuestion(row, index) {
      console.log('删除题目')
      console.log(row)
      console.log(row.id)

      this.$confirm('确定删除本道题吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (row.id) {
          console.log('删除已保存题目')
          adminDeleteQuestion({
            questionId: row.id,
          }).then((res) => {
            console.log('删除题目')
            console.log(res)
            if (res.is_delete) {
              this.$message.success('删除成功')
              this.adminGetTestQuestionByBankIdAndCodeOther()()
            }
          })
        } else {
          console.log('未保存的题目')

          this.specialQuestionTypesList.splice(index, 1)
        }
      })
    },

    adminGetTestQuestionByBankIdAndCodeOther() {
      // this.code_other
      adminGetTestQuestionByBankIdAndCodeOther({
        code_other: this.code_other,
      }).then((res) => {
        console.log(res, 89456416)
        this.questionList = res.questionList
        this.form.title_other = res.questionList[0].title_other
        this.form.title_other_md = res.questionList[0].title_other_md
        this.form.type = res.questionList[0].type
        this.form1.specialQuestionTypes = []
        this.questionList.map((item) => {
          item.tagIdArr = []
          if (item.tagRelationInfoArr.length != 0) {
            item.tagRelationInfoArr.map((item1) => {
              item.tagIdArr.push(item1.tag_id)
            })
          }
        })

        console.log('this.questionList:', this.questionList)
        console.log(
          'this.specialQuestionTypesList:',
          this.specialQuestionTypesList
        )
        this.specialQuestionTypesList = []
        // tagIdArr
        this.questionList.map((item) => {
          // let replaceIndex = -1
          // this.specialQuestionTypesList.forEach((specItem, index) => {
          //   if (specItem.title_md === item.title_md) {
          //     replaceIndex = index
          //   }
          // })
          // if (replaceIndex !== -1) {
          //   this.specialQuestionTypesList[replaceIndex] = item
          // } else {
          this.specialQuestionTypesList.push({
            title_md: item.title_md,
            judge_answer: item.answer,
            answer: item.answer,
            title: item.title,
            type: item.type_other,
            // judge_answer: item.judge_answer,
            resolution: item.analysis,
            analysis_md: item.analysis_md,
            options: JSON.parse(item.options),
            options_md: JSON.parse(item.options_md),
            tagIdArr: item.tagIdArr,
            id: item.id,
            sort_num: item.sort_num,
          })
          // }
        })
        // this.specialQuestionTypesList = this.form1.specialQuestionTypes
      })
    },

    addNewQuestionType(row, index) {
      console.log('题目信息')
      console.log(row, index)
      this.indexNum = index
      if (row.id) {
        let obj = row

        if (this.form.show_type === true) {
          this.form.show_type = '2'
          this.form.title_str = obj.title_md
        } else {
          this.form.show_type = '1'
          this.form.title_str = this.getSimpleText(obj.title)
        }
        if (obj.type == '3') {
          obj.options[0].title = 'A'
          obj.options[0].content = '正确'
          obj.options[1].title = 'B'
          obj.options[1].content = '错误'
          this.form.final_answer = obj.judge_answer
        }
        if (obj.type == '1') {
          this.form.final_answer = obj.answer
        }

        console.log('题目ID')
        console.log(obj.type)
        console.log(row.sort_num)

        if (this.$route.query.code_other) {
          console.log('特殊题目保存')
          this.form.sort_num = row.sort_num
        }

        adminAddOrUpdateQuestion({
          code_other: this.code_other,
          title_other: this.form.title_other,
          title_other_md: this.form.title_other_md,
          show_type: this.form.show_type,
          title_md: obj.title_md,
          options_md: JSON.stringify(obj.options_md),
          analysis_md: obj.analysis_md,
          questionBankId: this.bank_id, //题库id
          questionId: row.id, // 区分oj的Id
          subject_id: this.subject_id, //科目id
          type: this.form.type, //题库类型
          type_other: obj.type,
          title: obj.title, //题目名称
          title_str: this.form.title_str, //title 字符串
          options: JSON.stringify(obj.options), //单选题
          answer: this.form.final_answer, //答案
          analysis: obj.resolution, //试题解析
          sort_num: this.form.sort_num, //排序号
          curriculum_id: null, //课程体系id
          lession_id: null, //讲次id
          tagIdArr: JSON.stringify(obj.tagIdArr),
        }).then((res) => {
          console.log('录入试题')
          console.log(res)
          this.code_other = res.code_other
          this.$message.success('编辑成功')
          this.adminGetTestQuestionByBankIdAndCodeOther()
          this.form.show_type = this.formType
        })
      } else {
        // let obj = {}
        // this.specialQuestionTypesList.map((item) => {
        //   obj = item
        // })
        let obj = row
        if (this.form.show_type === true) {
          this.form.show_type = '2'
          this.form.title_str = obj.title_md
        } else {
          this.form.show_type = '1'
          this.form.title_str = this.getSimpleText(obj.title)
        }
        if (obj.type == '3') {
          obj.options[0].title = 'A'
          obj.options[0].content = '正确'
          obj.options[1].title = 'B'
          obj.options[1].content = '错误'
          this.form.final_answer = obj.judge_answer
        }
        if (obj.type == '1') {
          this.form.final_answer = obj.answer
        }

        adminAddOrUpdateQuestion({
          code_other: this.code_other, // 题目序号
          title_other: this.form.title_other,
          title_other_md: this.form.title_other_md,
          show_type: this.form.show_type,
          title_md: obj.title_md,
          options_md: JSON.stringify(obj.options_md),
          analysis_md: obj.analysis_md,
          questionBankId: this.bank_id, //题库id
          subject_id: this.subject_id, //科目id
          type: this.form.type, //题库类型
          type_other: obj.type,
          title: obj.title, //题目名称
          title_str: this.form.title_str, //title 字符串
          options: JSON.stringify(obj.options), //单选题
          answer: this.form.final_answer, //答案
          analysis: obj.resolution, //试题解析
          sort_num: parseFloat(this.form.sort_num) + index, //排序号
          curriculum_id: null, //课程体系id
          lession_id: null, //讲次id
          tagIdArr: JSON.stringify(obj.tagIdArr),
        }).then((res) => {
          console.log('录入试题')
          console.log(res)
          if (res.is_created) {
            // code_other: this.code_other,
            this.code_other = res.code_other
            this.$message.success('录入成功')
            // this.form.sort_num = parseFloat(this.form.sort_num) + 1
            this.adminGetTestQuestionByBankIdAndCodeOther()

            this.form.show_type = this.formType
            this.form.title_str = ''

            // this.ResetForm1();
            // this.ResetTinymce();
          }
        })
      }
    },
    adminGetTestQuestionTagListBySubjectIdWithoutPage() {
      console.log('当前科目')
      console.log(this.$route.query.subject_id)

      adminGetTestQuestionTagListBySubjectIdWithoutPage({
        subject_id: this.$route.query.subject_id,
      }).then((res) => {
        this.testQuestionTagList = res.testQuestionTagList
        console.log('科目知识点列表')
        console.log(res)
        console.log(this.testQuestionTagList)

        if (sessionStorage.getItem('ExamData') != null) {
          //编辑题目
          var arr = this.question.tagTitleStr.split(',')
          console.log('当前知识点')
          console.log(arr)

          for (let i = 0; i < arr.length; i++) {
            console.log('本题知识点')
            console.log(arr[i])

            for (let j = 0; j < this.testQuestionTagList.length; j++) {
              if (arr[i] == this.testQuestionTagList[j].title) {
                this.form.tagIdArr.push(this.testQuestionTagList[j].id)
              }
            }
          }
        }
      })
    },
    changeMardownD(val) {
      this.specialQuestionTypesList[this.indexNum].options_md[3].content = val
    },
    SaveMarkDownD(md, html) {
      console.log(html)
      console.log(md)
      this.specialQuestionTypesList[this.indexNum].options_md[3].content = md
    },
    changeMardownC(val) {
      this.specialQuestionTypesList[this.indexNum].options_md[2].content = val
    },
    SaveMarkDownC(md, html) {
      console.log(html)
      console.log(md)
      this.specialQuestionTypesList[this.indexNum].options_md[2].content = md
    },
    changeMardownB(val) {
      this.specialQuestionTypesList[this.indexNum].options_md[1].content = val
    },
    SaveMarkDownB(md, html) {
      console.log(html)
      console.log(md)
      this.specialQuestionTypesList[this.indexNum].options_md[1].content = md
    },
    changeMardownA(val) {
      this.specialQuestionTypesList[this.indexNum].options_md[0].content = val
    },
    SaveMarkDownA(md, html) {
      console.log(html)
      console.log(md)
      this.specialQuestionTypesList[this.indexNum].options_md[0].content = md
    },
    changeMardownTitle2(val) {
      console.log(val, 123456)
      console.log(this.indexNum, 123456)
      this.specialQuestionTypesList[this.indexNum].analysis_md = val
    },
    SaveMarkDownTitle2(md, html) {
      console.log(html)
      console.log(md)
      this.specialQuestionTypesList[this.indexNum].analysis_md = md
    },
    changeMardownTitle(val) {
      console.log(val, 123456)
      console.log(this.indexNum, 123456)
      this.specialQuestionTypesList[this.indexNum].title_md = val
    },
    SaveMarkDownTitle(md, html) {
      console.log(html)
      console.log(md)
      this.specialQuestionTypesList[this.indexNum].title_md = md
    },
    AddOneChoice5(row, index) {
      console.log(row, 11112343)
      this.indexNum = index
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
        this.drawer_d1 = true
      })
    },
    AddOneChoice4(row, index) {
      console.log(row, 11112343)
      this.indexNum = index
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
        this.drawer_c1 = true
      })
    },
    AddOneChoice3(row, index) {
      console.log(row, 11112343)
      this.indexNum = index
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
        this.drawer_b1 = true
      })
    },
    AddOneChoice2(row, index) {
      console.log(row, 11112343)
      this.indexNum = index
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
        this.drawer_a1 = true
        // this.specialQuestionTypesList[index].options[0].content = row.options[0].content
      })
    },
    AddOneChoiceanalysis(row, index) {
      console.log(row, 12345646)
      console.log(index, 12345646)
      this.indexNum = index
      this.isShow = false
      this.$nextTick(() => {
        this.isShow = true
        this.drawer_title2 = true
      })
    },
    AddOneChoice1(row, index) {
      let that = this
      that.drawer_titleContent = true
      that.isShow = false
      that.$nextTick(() => {
        that.isShow = true
        that.indexNum = index
        console.log(row, 12345646)
        console.log(that.specialQuestionTypesList, 12345646)
        if (row.title == '') {
          this.specialQuestionTypesList[this.indexNum].title = ''
        } else {
          this.specialQuestionTypesList[this.indexNum].title = row.title
        }
      })
    },
    addTrueOrFalse() {
      this.form2 = {
        tagIdArr: [],
        title_md: '',
        analysis_md: '无',
        answer: '',
        title: '',
        type: '3',
        judge_answer: '',
        resolution: '无',
        options_md: [
          {
            title: 'A',
            content: '',
          },
          {
            title: 'B',
            content: '',
          },
          {
            title: 'C',
            content: '',
          },
          {
            title: 'D',
            content: '',
          },
        ],
        options: [
          {
            title: 'A',
            content: '',
          },
          {
            title: 'B',
            content: '',
          },
          {
            title: 'C',
            content: '',
          },
          {
            title: 'D',
            content: '',
          },
        ],
      }
      this.$nextTick(() => {
        this.specialQuestionTypesList.push(this.form2)
        console.log(this.specialQuestionTypesList, 778858555)
        // this.specialQuestionTypesList.push({ tagIdArr: [], title_md: "", analysis_md: '', answer: '', title: "", type: '3', judge_answer: '', resolution: '', options: [{ title: "A", content: "" }, { title: "B", content: "" }, { title: "C", content: "" }, { title: "D", content: "" }], options_md: [{ title: "A", content: "" }, { title: "B", content: "" }, { title: "C", content: "" }, { title: "D", content: "" }] })
      })
    },
    choiceQuestion() {
      this.form2 = {
        tagIdArr: [],
        title_md: '',
        analysis_md: '无',
        answer: '',
        title: '',
        type: '1',
        judge_answer: '',
        resolution: '无',
        options_md: [
          {
            title: 'A',
            content: '',
          },
          {
            title: 'B',
            content: '',
          },
          {
            title: 'C',
            content: '',
          },
          {
            title: 'D',
            content: '',
          },
        ],
        options: [
          {
            title: 'A',
            content: '',
          },
          {
            title: 'B',
            content: '',
          },
          {
            title: 'C',
            content: '',
          },
          {
            title: 'D',
            content: '',
          },
        ],
      }
      this.$nextTick(() => {
        console.log(this.$refs.titleContent, 78956333)

        this.specialQuestionTypesList.push(this.form2)
        console.log(this.specialQuestionTypesList, 778858555)

        //this.specialQuestionTypesList.push({ tagIdArr: [], title_md: "", analysis_md: '', answer: '', title: "", type: '1', judge_answer: '', resolution: '', options: [{ title: "A", content: "" }, { title: "B", content: "" }, { title: "C", content: "" }, { title: "D", content: "" }], options_md: [{ title: "A", content: "" }, { title: "B", content: "" }, { title: "C", content: "" }, { title: "D", content: "" }] })
      })
    },
    goback() {
      if (this.$route.query.typeIndex == 1) {
        this.$router.push({
          name: 'topic',
        })
      } else if (this.$route.query.typeIndex == 2) {
        this.$router.push({
          name: 'questionBankAdminDetails',
          query: {
            id: this.$route.query.id,
            subject_id: this.$route.query.subject_id,
          },
        })
      }
      // if (this.$route.query.tpye == '1') {
      //     console.log(123456);
      //     this.$router.push({
      //         name: "own-question",
      //     });
      // } else if (this.$route.query.tpye == '2') {
      //     console.log(123456);
      //     this.$router.push({
      //         name: "questionlist",
      //         query: {
      //             id: this.$route.query.id,
      //             title: this.$route.query.title,
      //             subject_id: this.$route.query.subject_id,
      //             question_num: this.$route.query.question_num,
      //         },
      //     });

      // } else if (this.$route.query.tpye == '3') {
      //     console.log(123456);
      //     this.$router.push({
      //         name: "questionlist",
      //         query: {
      //             id: this.$route.query.id,
      //             title: this.$route.query.title,
      //             subject_id: this.$route.query.subject_id,
      //             question_num: this.$route.query.question_num,
      //         },
      //     });

      // }
    },
    changeMardownTitleOther(val) {
      this.form.title_other_md = val
    },
    SaveMarkDownTitleOther(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.form.title_other_md = md
    },
    changeMardown5(val) {
      this.form.analysis_md = val
    },
    SaveMarkDown5(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.form.analysis_md = md
    },
    changeMardown4(val) {
      this.form.options_md[3].content = val
    },
    SaveMarkDown4(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.form.options_md[3].content = md
    },
    changeMardown3(val) {
      this.form.options_md[2].content = val
    },
    SaveMarkDown3(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.form.options_md[2].content = md
    },
    changeMardown2(val) {
      this.form.options_md[1].content = val
    },
    SaveMarkDown2(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.form.options_md[1].content = md
    },
    changeMardown1(val) {
      this.form.options_md[0].content = val
    },
    SaveMarkDown1(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.form.options_md[0].content = md
    },
    changeMardown(val) {
      this.form.title_md = val
      this.form.title_str = val
    },
    SaveMarkDown(md, html) {
      console.log('保存markdown')
      console.log(md, 45412)
      console.log(html, 13223)
      this.form.title = md
    },
    // changeSwitch1(val) {
    //     console.log(val, 789465)
    //     this.show_type1 = val.show_type
    // },
    changeSwitch(val) {
      console.log(val, 123456789)
      this.formType = val
      let show_type = 1

      if (val == true) {
        show_type = 2
      } else {
        show_type = 1
      }
      if (this.code_other) {
        adminUpdateQuestionShowType({
          show_type: show_type,
          code_other: this.code_other,
        }).then((res) => {
          console.log(res)
          this.$message.success('切换成功')
        })
      }
    },
    //提取纯文字
    getSimpleText(html) {
      var re1 = new RegExp('<.+?>', 'g') //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '') //执行替换成空字符
      return msg
    },

    AddOneChoice(key) {
      if (key == 'a') {
        this.drawer_a = true
      } else if (key == 'b') {
        this.drawer_b = true
      } else if (key == 'c') {
        this.drawer_c = true
      } else if (key == 'd') {
        this.drawer_d = true
      } else if (key == 't') {
        this.drawer_title = true
      } else if (key == 's') {
        this.drawer_s = true
      } else if (key == 'short') {
        this.drawer_short = true
      } else if (key == 't3') {
        this.drawer_title3 = true
      }
    },

    /*
    var activeEditor = tinymce.activeEditor; 
    var editBody = activeEditor.getBody(); 
    activeEditor.selection.select(editBody); 
    var text = activeEditor.selection.getContent( { ‘format’ : ‘text’ } );
    */

    uploadFile() { },
    addAnswers(item, index) {
      console.log(index, 123456)
      console.log(item, 123456)
      this.form.answerArr.map((row) => {
        if (index == row.id) {
          console.log(123456, 1234756)
          row.content = row.content + '┇'
        }
      })
    },
    removeAnswer(item) {
      var index = this.form.answerArr.indexOf(item)
      if (index !== -1) {
        this.form.answerArr.splice(index, 1)
      }
    },
    addAnswer() {
      console.log(this.form.answerArr.length, 123456)
      const answer = {
        id: this.form.answerArr.length + 1,
        content: '',
      }

      this.form.answerArr.push(answer)

      console.log(this.form.answerArr)
    },
    //录入试题
    adminAddOrUpdateQuestion() {
      console.log('录题参数')
      console.log(this.form)
      console.log(this.bank_id)
      console.log(this.subject_id)
      console.log(this.form.sort_num)

      if (this.form.show_type === true) {
        this.form.show_type = '2'
        this.form.title_str = this.form.title_md
      } else {
        this.form.show_type = '1'
        this.form.title_str = this.getSimpleText(this.form.title)
      }

      if (this.form.type == '1') {
        this.form.final_answer = this.form.answer
      } else if (this.form.type == '2') {
        this.form.final_answer = this.form.answerlist.join(',')
      } else if (this.form.type == '3') {
        this.form.options[0].title = 'A'
        this.form.options[0].content = '正确'

        this.form.options[1].title = 'B'
        this.form.options[1].content = '错误'

        this.form.final_answer = this.form.judge_answer
      } else if (this.form.type == '4') {
        console.log('填空题')
        var answer = []
        for (let k = 0; k < this.form.answerArr.length; k++) {
          answer.push(this.form.answerArr[k].content)
        }
        this.form.final_answer = answer.join('┅')
        console.log(this.form.final_answer, 123465)
      } else if (this.form.type == '5') {
        console.log('简单题录入')
        this.form.final_answer = this.form.short_answer
      } else if (this.form.type == '6') {
        console.log('综合题')
        this.form.final_answer = JSON.stringify(
          this.form.fileList1.concat(this.form.fileList2)
        )
      }

      console.log('录题参数111', 123465)
      console.log(this.form)

      if (sessionStorage.getItem('ExamData') != null) {
        adminAddOrUpdateQuestion({
          show_type: this.form.show_type,
          title_md: this.form.title_md,
          options_md: JSON.stringify(this.form.options_md),
          analysis_md: this.form.analysis_md,
          questionId: JSON.parse(sessionStorage.getItem('ExamData')).id,
          oj_problem_id: this.form.type == 9 && this.ojSelectedItem ? this.ojSelectedItem.id : JSON.parse(sessionStorage.getItem('ExamData')).oj_problem_id, // 区分oj的Id
          questionBankId: this.bank_id, //题库id
          subject_id: this.subject_id, //科目id
          type: this.form.type, //题库类型
          title: this.form.title, //题目名称
          title_str: this.form.title_str, //title 字符串
          options: JSON.stringify(this.form.options), //单选题
          answer: this.form.final_answer, //答案
          analysis: this.form.resolution, //试题解析
          sort_num: this.form.sort_num, //排序号
          curriculum_id: null, //课程体系id
          lession_id: null, //讲次id
          schoolId: this.$route.query.schoolId,
          tagIdArr: JSON.stringify(this.form.tagIdArr),
        }).then((res) => {
          console.log('录入试题')
          console.log(res)
          if (res.is_update) {
            this.$message.success('更新成功')
            this.form.show_type = this.formType

            // this.$router.push({
            //   name: "questionlist",
            //   query: {
            //     id: this.bank_id,
            //     title: this.title,
            //   },
            // });
          }
        })
      } else {
        adminAddOrUpdateQuestion({
          show_type: this.form.show_type,
          title_md: this.form.title_md,
          options_md: JSON.stringify(this.form.options_md),
          analysis_md: this.form.analysis_md,
          oj_problem_id: this.form.type == 9 && this.ojSelectedItem ? this.ojSelectedItem.id : null, // 区分oj的Id
          questionBankId: this.bank_id, //题库id
          subject_id: this.subject_id, //科目id
          type: this.form.type, //题库类型
          title: this.form.title, //题目名称
          title_str: this.form.title_str, //title 字符串
          options: JSON.stringify(this.form.options), //单选题
          answer: this.form.final_answer, //答案
          analysis: this.form.resolution, //试题解析
          sort_num: this.form.sort_num, //排序号
          curriculum_id: null, //课程体系id
          lession_id: null, //讲次id
          tagIdArr: JSON.stringify(this.form.tagIdArr),
        }).then((res) => {
          console.log('录入试题')
          console.log(res)
          if (res.is_created) {
            this.$message.success('录入成功')
            this.form.show_type = this.formType
            this.nextForm()
            this.ResetTinymce()
          }
        })
      }
    },
    //清空输入
    // ResetForm1() {
    //   console.log(this.form.show_type, 4512)

    //   this.form = {
    //     sort_num: parseFloat(this.form.sort_num) + 1,
    //     show_type: false,
    //     title_md: '',
    //     analysis_md: '无',
    //     options_md: [
    //       {
    //         title: 'A',
    //         content: '',
    //       },
    //       {
    //         title: 'B',
    //         content: '',
    //       },
    //       {
    //         title: 'C',
    //         content: '',
    //       },
    //       {
    //         title: 'D',
    //         content: '',
    //       },
    //     ],
    //     type: this.form.type,
    //     title: '',
    //     title_str: '', //富文本提取纯文本
    //     options: [
    //       {
    //         title: 'A',
    //         content: '',
    //       },
    //       {
    //         title: 'B',
    //         content: '',
    //       },
    //       {
    //         title: 'C',
    //         content: '',
    //       },
    //       {
    //         title: 'D',
    //         content: '',
    //       },
    //     ],

    //     final_answer: '', //最终答案
    //     answer: '', //答案
    //     resolution: '无', // 试题解析
    //     answerlist: [], //多选题答案
    //     judge_answer: '', //判断题答案
    //     short_answer: '', //简单题答案
    //     answerArr: [
    //       {
    //         id: 1,
    //         content: '',
    //       },
    //     ],
    //     fileList: [], // 项目源文件
    //   }
    // },
    nextForm() {
      console.log(this.form.show_type, 4512)
      if (this.$route.query && this.$route.query.question_num) {
        const question_num = parseFloat(this.$route.query.question_num)
        const currentRoute = this.$route
        this.$router.replace({
          ...currentRoute,
          query: {
            ...this.$route.query,
            ...{ question_num: question_num + 1 },
          },
        })
      }
      this.form = {
        sort_num: parseFloat(this.form.sort_num) + 1,
        show_type: true,
        title_md: '',
        analysis_md: '无',
        options_md: [
          {
            title: 'A',
            content: '',
          },
          {
            title: 'B',
            content: '',
          },
          {
            title: 'C',
            content: '',
          },
          {
            title: 'D',
            content: '',
          },
        ],
        type: 1,
        title: '',
        title_str: '', //富文本提取纯文本
        options: [
          {
            title: 'A',
            content: '',
          },
          {
            title: 'B',
            content: '',
          },
          {
            title: 'C',
            content: '',
          },
          {
            title: 'D',
            content: '',
          },
        ],

        final_answer: '', //最终答案
        answer: '', //答案
        resolution: '无', // 试题解析
        answerlist: [], //多选题答案
        judge_answer: '', //判断题答案
        short_answer: '', //简单题答案
        answerArr: [
          {
            id: 1,
            content: '',
          },
        ],
        fileList: [], // 项目源文件
      }
    },
    ResetTinymce() {
      if (this.$refs.title) {
        this.$refs.title.setContent('')
      }
      if (this.$refs.question_a) {
        this.$refs.question_a.setContent('')
      }
      if (this.$refs.question_b) {
        this.$refs.question_b.setContent('')
      }
      if (this.$refs.question_c) {
        this.$refs.question_c.setContent('')
      }
      if (this.$refs.question_d) {
        this.$refs.question_d.setContent('')
      }
      if (this.$refs.resolution) {
        this.$refs.resolution.setContent('')
      }
      if (this.$refs.short_answer) {
        this.$refs.short_answer.setContent('')
      }
    },

    async handleChangeFile1(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, '1')
      }
    },

    async handleChangeFile2(file, fileList) {
      if (!this.uploadFileTime) {
        await this.uploadFileOss(fileList, '2')
      }
    },

    async uploadFileOss(list, cmd) {
      this.uploadFileTime = true
      await uploadFile(
        list,
        'plat_exam/files/' + this.$store.state.user.userInfo.code
      ).then((res) => {
        console.log('上传回调函数')
        console.log(res)
        if (cmd == '1') {
          this.form.fileList1 = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
            },
          ]
        } else if (cmd == '2') {
          this.form.fileList2 = [
            {
              url: res[0].url,
              name: res[0].url.split('/')[res[0].url.split('/').length - 1],
            },
          ]
        }
        this.uploadFileTime = false
      })
    },
    // OJ部分
    getAdminGetOjProblemList() {
      adminGetOjProblemList(this.ojParams).then(res => {
        console.log(res)
        this.ojProblemList = res.ojProblemList;
        this.ojParams.total = res.total;
      })
    },
    // 关闭抽屉
    handleCloseOjDrawer(done) {
      // this.$confirm('确认关闭？')
      //   .then(() => {
      //     this.ojDrawerShow = false;
      //     this.ojSelectedItem = null;
      //     done();
      //   })
      //   .catch(() => { });
      done();
    },
    // 切换OJ列表
    handleOjChangePage(page) {
      this.ojParams.page_no = page;
      this.getAdminGetOjProblemList();
    },
    // 选择OJ题
    methodSelectOj(row) {
      console.log(row)
      this.ojSelectedItem = row;
      this.form.title = `${row.code} ${row.title}`;
      this.ojDrawerShow = false
    },
  },
}
</script>

<style lang="scss" scoped>
.backStyle {
  // width:100%;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
}

.boxStyle {
  position: fixed;
  right: 30px;
  bottom: 30px;
  padding: 20px;
  background-color: #3f7af0;
  border-radius: 5px;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.newQuestion {
  padding: 10px;
}

.question-title1 {
  float: left;
  width: 90%;
  margin-left: 10px;
  padding: 5px;
  border-radius: 5px;
  background: #f1f7fe;
}

.newQuestion .wrapper {
  box-sizing: border-box;
  min-height: 100%;
  background: white;
  border-radius: 5px;
  padding: 20px;
  box-sizing: border-box;
  margin-top: 10px;

  .content {
    // margin-top: 20px;

    .question-title {
      float: left;
      width: calc(100vw - 410px);
      // min-width: 500px;
      // min-height: 20px;
      margin-left: 10px;
      padding: 20px;
      border-radius: 5px;
      background: #f1f7fe;
    }

    .question-title2 {
      float: left;
      width: calc(100vw - 390px);
      // min-width: 500px;
      // min-height: 20px;
      margin-left: 10px;
      padding: 20px;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #ccc;
    }

    .question-title3 {
      float: left;
      width: calc(100vw - 330px);
      border-radius: 5px;
      background: #fff;
      border: 1px solid #e3e1e1;
      line-height: 40px;
      height: 40px;
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .option-wrapper {
      float: left;
      width: 100%;
      margin-bottom: 20px;

      .option-tab {
        // float: left;
        margin-left: 10px;
        font-weight: bold;
      }

      .option-input1 {
        float: left;
        width: calc(100vw - 385px);
        // min-width: 500px;
        // min-height: 20px;
        // margin-left: 10px;
        padding: 20px;
        border-radius: 5px;
        background: #fff;
        border: 1px solid #e0e2e4;
      }

      .option-input2 {
        float: left;
        width: calc(100vw - 342px);
        // min-width: 500px;
        // min-height: 20px;
        // margin-left: 10px;
        padding: 20px;
        border-radius: 5px;
        background: #fff;
        border: 1px solid rgb(226, 226, 226);
      }

      .option-input {
        float: left;
        width: calc(100vw - 410px);
        // min-width: 500px;
        // min-height: 20px;
        margin-left: 10px;
        padding: 20px;
        border-radius: 5px;
        background: #f1f7fe;
      }

      .el-icon-edit {
        margin-left: 10px;
        cursor: pointer;
      }
    }

    .anwser_arr {
      width: 250px;
      margin-bottom: 10px;
    }

    .answer_tips {
      margin-top: 20px;
    }

    .submit {
      text-align: left;
    }
  }
}

/deep/ .hljs {
  background: transparent;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}

/deep/ .markdown_wrapper .mavon-editor {
  height: calc(100vh - 38px);
}
</style>
